import { apiClient } from './api';
import { OrderStatus } from '@/types';

export interface AdminOrderQuery {
  status?: OrderStatus;
  restaurantId?: string;
  courierId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  search?: string;
  /** Kurye atanmamış siparişler (PREPARING, courierId null) */
  unassignedOnly?: boolean;
  /** En az bu kadar dakikadır bekleyen (unassignedOnly ile) */
  minWaitMinutes?: number;
}

export interface AdminOrderStatusCounts {
  CREATED: number;
  PREPARING: number;
  READY: number;
  ON_WAY: number;
  DELIVERED: number;
  CANCELLED: number;
}

export interface AdminOrderListResponse {
  orders: any[];
  total: number;
  page: number;
  limit: number;
  statusCounts: AdminOrderStatusCounts;
}

export interface OrderAlert {
  orderId: string;
  orderNumber: string;
  issue: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  createdAt: string;
}

export interface AdminUpdateOrderStatusDto {
  status: OrderStatus;
  reason?: string;
}

export interface AdminReassignCourierDto {
  courierId: string;
}

export const adminOrderService = {
  async listAllOrders(query: AdminOrderQuery): Promise<AdminOrderListResponse> {
    const params = Object.fromEntries(
      Object.entries(query).filter(([k, v]) => {
        if (v === undefined || v === '') return false;
        if (k === 'unassignedOnly' && v === false) return false;
        return true;
      })
    ) as Record<string, string | number | boolean>;
    const response = await apiClient.get<AdminOrderListResponse>('/admin/orders', {
      params,
    });
    return response.data.data;
  },

  async getOrderDetails(orderId: string) {
    const response = await apiClient.get(`/admin/orders/${orderId}`);
    return response.data.data;
  },

  async getOrderAlerts(): Promise<OrderAlert[]> {
    const response = await apiClient.get<OrderAlert[]>('/admin/orders/alerts/list');
    return response.data.data;
  },

  async updateOrderStatus(orderId: string, dto: AdminUpdateOrderStatusDto) {
    const response = await apiClient.patch(`/admin/orders/${orderId}/status`, dto);
    return response.data.data;
  },

  async reassignCourier(orderId: string, dto: AdminReassignCourierDto) {
    const response = await apiClient.patch(`/admin/orders/${orderId}/courier`, dto);
    return response.data.data;
  },
};
